<template>
  <div class="home">
    <div style="       width: 80%;    margin: auto;">
    
     <md-field>
      <label>Username</label>
      <md-input type="text"></md-input>
    </md-field>
      <md-field>
      <label>Password</label>
      <md-input  type="password"></md-input>
    </md-field>
     <md-button class="md-raised md-primary" @click="$router.push('generate')">Login</md-button>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'HomeMobile',
  components: {
  }
}
</script>
